import React from 'react';
import { Badge } from '../ui/badge';
import { cn, getStatusClass } from '../../lib/utils';

const StatusBadge = ({ status, className, size = 'default' }) => {
  const displayStatus = status?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  
  const sizeClasses = {
    xs: 'text-[10px] px-1 py-0 h-4',
    sm: 'text-xs px-1.5 py-0.5',
    default: '',
  };
  
  return (
    <Badge 
      variant="outline" 
      className={cn(
        "font-medium border",
        getStatusClass(status),
        sizeClasses[size],
        className
      )}
    >
      {displayStatus}
    </Badge>
  );
};

export default StatusBadge;
